import React from "react";
import SiteHeader from "@/components/layout/site-header";

const MainNavLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="w-full h-full mx-auto flex flex-col">
      <SiteHeader />
      <main className="flex-1 overflow-hidden p-6">
        {children}
      </main>
    </div>
  )
}

export default MainNavLayout;
